import React, { useMemo } from 'react';
import DragWrapper from '../DragWrapper';
import { useProjectState, setProjectState } from '@starflow/app/store';
import Flow from './FlowEntry';
import { flowScrollAreaId } from '../../../../constants';

export const dragWrapperId = 'flow-drag-wrapper';

const FlowContainer = () => {
  const flows = useProjectState('flows');
  if (!flows) return;

  const nodeMap = useProjectState('nodeMap');
  const transferIdIntoNodes = useMemo(() => {
    return flows.map((flow) => {
      return {
        ...flow,
        data: {
          ...flow.data,
          nodes: flow.data?.nodes.map((id) => nodeMap[id]),
        },
      };
    });
  }, [flows, nodeMap]);

  const formatNodesIntoIds = (flows) => {
    const newFlows = flows.map((flow) => {
      return {
        ...flow,
        data: {
          ...flow.data,
          nodes: flow.data.nodes.map((node) => node.id),
        },
      };
    });
    setProjectState({ flows: newFlows });
  };

  return (
    <div className="border-t-[1px] border-[#EBEBEB] bg-[#eff0f5] relative" id={dragWrapperId}>
      <DragWrapper
        id={flowScrollAreaId}
        sortUpdate={(flows) => formatNodesIntoIds(flows)}
        dataList={transferIdIntoNodes}
        className="flex items-start flex-col overflow-auto h-full tiny-scrollbar"
        style={{ maxHeight: `${innerHeight / 2 - 80}px` }}
      >
        {transferIdIntoNodes.map((flow, idx) => (
          <Flow key={idx} flow={flow} sortNum={idx} />
        ))}
      </DragWrapper>
    </div>
  );
};

export default FlowContainer;
